module.exports = __webpack_public_path__ + "media/images/webpage/shared/spotmap/location__tourspot--here-fde373015b0fb03a98708394dae111ab.svg";